import RestoreToVersionModal from './RestoreToVersionModal';

export default RestoreToVersionModal;
